import React from "react";
import { Dialog, DialogContent, DialogTitle, Tooltip, IconButton } from "@mui/material";
import { alpha } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import ReactPlayer from "react-player";
import CTLDialogContent from "../styles/CTLDialogContent";
import { useMaterialUIController } from "context";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import VideocamIcon from "@mui/icons-material/Videocam";

export default function VoicePlayAudio({ value, row, compact = false }) {
  const id = value;

  const type = row?.streamType;

  const [open, setOpen] = React.useState(false);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const domain = AuthenticationService?.getXmppPrimaryDomain();

  const serverUrl =
    domain && domain.trim() !== ""
      ? domain.replace(/^wss:/i, "https:").replace(/^ws:/i, "https:") +
        `/LiveApp/streams/${id}.mp4`
      : `https://conf.coraltele.com:5443/LiveApp/streams/${id}.mp4`;

  const isAudio = type === "audio";
  const isVideo = type === "video";
  const canPlay = isAudio || isVideo;

  return (
    <div>
      {canPlay && (
        <Tooltip title={isAudio ? "Play Audio" : "Play Video"}>
          <IconButton
            size="small"
            onClick={handleClickOpen}
            sx={{
              width: compact ? 24 : 30,
              height: compact ? 24 : 30,
              p: compact ? 0.25 : 0.35,
              color: "#fff",
              borderRadius: 1,
              border: (theme) =>
                `1px solid ${alpha(
                  isAudio ? theme.palette.info.main : theme.palette.success.main,
                  0.55,
                )}`,
              background: (theme) =>
                isAudio
                  ? `linear-gradient(135deg, ${theme.palette.info.main}, ${theme.palette.info.dark})`
                  : `linear-gradient(135deg, ${theme.palette.success.main}, ${theme.palette.success.dark})`,
              boxShadow: (theme) =>
                `0 5px 12px ${alpha(
                  isAudio ? theme.palette.info.main : theme.palette.success.main,
                  0.35,
                )}`,
              transition: "all 0.18s ease",
              "&:hover": {
                transform: "translateY(-1px)",
                boxShadow: (theme) =>
                  `0 8px 16px ${alpha(
                    isAudio ? theme.palette.info.main : theme.palette.success.main,
                    0.45,
                  )}`,
              },
            }}
          >
            {isAudio ? (
              <PlayArrowIcon sx={{ fontSize: compact ? 14 : 18, color: "#fff" }} />
            ) : (
              <VideocamIcon sx={{ fontSize: compact ? 13 : 16, color: "#fff" }} />
            )}
          </IconButton>
        </Tooltip>
      )}
      <Dialog
        onClose={handleClose}
        open={open}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: type === "video" ? { xs: "92vw", sm: 420 } : { xs: "88vw", sm: 340 },
            maxWidth: type === "video" ? 420 : 340,
            borderRadius: 2,
            overflow: "hidden",
            border: (theme) => `1px solid ${alpha(theme.palette.info.main, 0.22)}`,
            boxShadow: (theme) => `0 12px 30px ${alpha(theme.palette.common.black, 0.32)}`,
          },
        }}
        sx={(theme) => CTLDialogContent(theme, { darkMode })}
      >
        <DialogTitle
          sx={(theme) => ({
            ...CTLDialogContent(theme, { darkMode }),
            py: 1,
            pl: 1.5,
            pr: 4.5,
            fontSize: "0.86rem",
            fontWeight: 700,
            borderBottom: `1px solid ${alpha(theme.palette.info.main, 0.16)}`,
          })}
        >
          {type === "audio"
            ? "Playing Recorded Audio Stream..."
            : "Playing Recorded Video Stream..."}
          <IconButton
            color="error"
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 6,
              top: 6,
              p: 0.55,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={(theme) => ({
            ...CTLDialogContent(theme, { darkMode }),
            p: 1,
          })}
        >
          <ReactPlayer
            url={serverUrl}
            width="100%"
            height="236px"
            playing={true}
            controls={true}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
